














































import {
  defineComponent, PropType, computed, toRefs,
} from '@nuxtjs/composition-api';
import { SfAccordion, SfTable } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import { getProductWeightAndDimensions } from '~/modules/catalog/product/getters/productGetters';
import SvgImage from '~/components/General/SvgImage.vue';
import { useProductStore } from '~/modules/catalog/stores/product';

export default defineComponent({
  components: {
    SfAccordion,
    SfTable,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    tab: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { lastOpenedTabId, resetLastOpenedTabId } = toRefs(useProductStore());

    const applyRegex = (regexp: RegExp) => [...getProductWeightAndDimensions(props.product).matchAll(regexp)]
      .map((m) => ({
        label: m[1]?.trim(),
        value: m[2]?.trim(),
      }));

    const sizes = computed(() => {
      const arr = applyRegex(/([^:]*):([^;]*)(?:;|$)/g);
      if (arr.length === 0) return applyRegex(/([^-]*) - ([^<>br]*)(?:<br>|$)/g);
      return arr;
    });

    return {
      lastOpenedTabId,
      resetLastOpenedTabId,
      sizes,
      getProductWeightAndDimensions,
    };
  },
});
